module.exports = __webpack_public_path__ + "static/media/Clear_Icon_Active.6129ab0a.svg";